import { render, staticRenderFns } from "./googleAds.vue?vue&type=template&id=29fa1707&scoped=true&"
import script from "./googleAds.vue?vue&type=script&lang=js&"
export * from "./googleAds.vue?vue&type=script&lang=js&"
import style0 from "./googleAds.vue?vue&type=style&index=0&id=29fa1707&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fa1707",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29fa1707')) {
      api.createRecord('29fa1707', component.options)
    } else {
      api.reload('29fa1707', component.options)
    }
    module.hot.accept("./googleAds.vue?vue&type=template&id=29fa1707&scoped=true&", function () {
      api.rerender('29fa1707', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/googleAds.vue"
export default component.exports